<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'SupplyRequest.List_Title' | translateWF: 'Supply Request' }}</h1>
        @if (canCreate()) {
          <p-button [label]="'SupplyRequest.Create_Button' | translateWF: 'Create Supply Request'" icon="pi pi-plus" (click)="redirectToDetail()" />
        }
      </div>
    </div>

    <div class="cs-page-list-grid">
      <!-- Filters Panel -->
      @if (filtersConfig() && showFilters()) {
        <csl-dynamic-filters [filterConfig]="filtersConfig()!" [state]="filterState" />
      }

      <!-- Data Table Panel -->
      <p-panel [header]="'Supply_Requests' | translateWF: 'Supply Requests'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="dataSource()" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]" selectionMode="single">
            <ng-template #header>
              <tr>
                <th>{{ 'SupplyRequest.Id' | translateWF: 'Supply Request ID' }}</th>
                <th>Created By</th>
                <th>{{ 'SupplyRequest.Department' | translateWF: 'Department' }}</th>
                <th>{{ 'SupplyRequest.Status' | translateWF: 'Status' }}</th>
                <th>{{ 'SupplyRequest.DateCreated' | translateWF: 'Date Created' }}</th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template #body let-item>
              @let strictSupplyRequest = getStrictSupplyRequest(item);
              <tr class="cursor-pointer" (click)="redirectToDetail(item.id)">
                <td>
                  <a>{{ strictSupplyRequest.number }}</a>
                </td>
                <td>{{ strictSupplyRequest.createdByUserLite?.firstName }} {{ strictSupplyRequest.createdByUserLite?.lastName }}</td>
                <td>
                  {{ localHelperService.getLocalizedValue(strictSupplyRequest.departmentName) }}
                </td>
                <td>
                  {{ statuses[strictSupplyRequest.status] }}
                </td>
                <td>
                  {{ strictSupplyRequest.createdDate | date: 'dd/MM/yyyy' }}
                </td>
                <td class="!text-end">
                  @if (canCreate()) {
                    <p-button icon="pi pi-pencil" variant="text" (onClick)="redirectToDetail(item.id)" />
                  }
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-card>
      </p-panel>
    </div>
  </div>
</main>

<p-toast position="top-center" />
